import React, { Fragment, useState } from 'react';
import { useHistory, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { BsFillBellFill } from 'react-icons/bs';
import { FaUserCircle } from 'react-icons/fa';
import { IsAuth } from '../../../../utils/Auth';
import GuestLinks from './GuestLinks';

const UserLinks = () => {
  const history = useHistory();

  const logoutHandler = () => {
    console.log('Logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // history.push(<GuestLinks />);

    // history.replace('/') || history.push('/');
  };

  return (
    <Fragment>
      <li className='nav-item'>
        <BsFillBellFill
          className='notificationBell mt-2'
          size={22}
          color='white'
        />
      </li>
      <div className='d-flex gap-2'>
        <FaUserCircle className='mt-1' color='white' size={25} />
        <li class='nav-item dropdown'>
          <a
            class='nav-link'
            href='#'
            id='navbarDarkDropdownMenuLink'
            role='button'
            data-bs-toggle='dropdown'
            aria-expanded='false'
          >
            {IsAuth().name}
          </a>
          <ul
            class='dropdown-menu dropdown-menu-dark rounded-1'
            aria-labelledby='navbarDarkDropdownMenuLink'
          >
            <li>
              <Link to='/profilepage' class='dropdown-item'>
                My Profile
              </Link>
            </li>
            <li>
              <hr class='dropdown-divider ms-1' />
            </li>
            <li>
              <Link to='/eventpage' class='dropdown-item'>
                My Events
              </Link>
            </li>
            <li>
              <hr class='dropdown-divider ms-1' />
            </li>
            <li>
              <Link class='dropdown-item' onClick={logoutHandler}>
                Log Out
              </Link>
            </li>
          </ul>
        </li>
      </div>
    </Fragment>
  );
};

export default UserLinks;
